module.exports = __webpack_public_path__ + "assets/e6486ed34bd6fc8b1ee21d394ddb0855.png";